/**
 * Der Sofortwert fuer ein Eingabefeld, dessen Aenderungen erst VERZOEGERT in die Adresse
 * geschrieben werden (Spezifikation § 4) - sonst schriebe jeder Tastendruck einen
 * Verlaufseintrag-Kandidaten, und Firefox/Safari drosseln so haeufige `replaceState`-Aufrufe (mit
 * Konsolenmeldung).
 *
 * FIXRUNDE 1 (Aufgabe 4): bis hierhin stand dasselbe Effektpaar DREIMAL wortgleich in
 * `BoardSeite.tsx`, `ZeitstrahlSeite.tsx` und `LieferantenSeite.tsx`, samt demselben
 * `eslint-disable-next-line react-hooks/exhaustive-deps`. Der Pruefbericht: "wer eine dieser
 * Kopien einmal falsch abschreibt - Abbruchbedingung oder Aufraeumen -, baut genau den Fehler ein,
 * den Punkt 1 der Pruefung ausgeschlossen hat." Eine einzige Fassung statt drei Abschriften.
 *
 * BEWUSST NICHT an `useAnsicht` gebunden: der Haken kennt nur ein Wertepaar (aktuell/Schreiber),
 * keine `Ansicht`. Das haelt ihn ohne Router-Kontext testbar (siehe
 * `test/komponenten/useEntprelltenAdresswert.test.tsx`) und wiederverwendbar fuer jeden
 * zukuenftigen entprellten Adressschreiber, nicht nur fuer die vier heutigen Seiten.
 */
import { useEffect, useState } from "react";

/** ~300 ms - derselbe Wert, den alle drei bisherigen Abschriften trugen (Aufgabe-4-Brief). */
const VORGABE_VERZOEGERUNG_MS = 300;

export function useEntprelltenAdresswert(
  wert: string,
  schreiben: (wert: string) => void,
  verzoegerungMs: number = VORGABE_VERZOEGERUNG_MS,
): [string, (wert: string) => void] {
  const [roh, setzeRoh] = useState(wert);

  // Ein externer Adresswechsel (Vor/Zurueck, ein Tieflink) zieht den Rohwert sofort nach.
  useEffect(() => setzeRoh(wert), [wert]);

  useEffect(() => {
    if (roh === wert) return;
    const marke = setTimeout(() => schreiben(roh), verzoegerungMs);
    return () => clearTimeout(marke);
    // `schreiben` haengt am jeweiligen Seitenzustand, der sich bei jedem Tastendruck aendern
    // wuerde - der Zeitgeber soll nur an `roh` haengen. Sicher, WEIL `schreiben` bei allen drei
    // Aufrufern selbst auf der Funktionsform von `setzeAnsicht` beruht (`alt => …`) und deshalb
    // unabhaengig davon korrekt bleibt, aus welchem Rendern heraus dieser Effekt ihn erreicht hat.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roh, verzoegerungMs]);

  return [roh, setzeRoh];
}
